import React from "react";
import { Drawer, Card, Row, Col } from "antd";
import { Line, Pie, Radar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  RadialLinearScale,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  RadialLinearScale,
  ArcElement,
  Tooltip,
  Legend
);

const DetailDrawer = ({
  open,
  setOpen,
  selectedMachine,
  selectedMachineId,
  loading,
}) => {
    console.log(selectedMachine);
    
  const lineData = {
    labels: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs"],
    datasets: [
      {
        label: "Üretim Miktarı",
        data: [12, 19, 3, 5, 2],
        borderColor: "rgba(75,192,192,1)",
        backgroundColor: "rgba(75,192,192,0.2)",
        tension: 0.4,
      },
    ],
  };

  const pieData = {
    labels: ["Aktif", "Pasif", "Bakımda"],
    datasets: [
      {
        data: [50, 30, 20],
        backgroundColor: ["#4CAF50", "#FF9800", "#F44336"],
      },
    ],
  };

  const radarData = {
    labels: ["Hız", "Güvenilirlik", "Bakım Maliyeti", "Verimlilik", "Esneklik"],
    datasets: [
      {
        label: "Makine Performansı",
        data: [80, 90, 70, 85, 60],
        backgroundColor: "rgba(54,162,235,0.2)",
        borderColor: "rgba(54,162,235,1)",
      },
    ],
  };

  return (
    <Drawer
      closable
      destroyOnClose
      size="large"
      title={
        <p style={{ fontSize: "18px", fontWeight: "bold" }}>
          Makine Rapor Detayları
        </p>
      }
      placement="right"
      open={open}
      loading={loading}
      onClose={() => setOpen(false)}
    >
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Card>
            <p style={{ fontSize: "16px", fontWeight: "bold" }}>
              {selectedMachine.name} / {selectedMachine.code} 
            </p>
            <p>Departman: {selectedMachine.departmentName}</p>
            <p>Kod: {selectedMachine.status}</p>
          </Card>
        </Col>

        <Col span={12}>
          <Card title="Performans Karşılaştırma">
            <Radar data={radarData} />
          </Card>
        </Col>

        <Col span={12}>
          <Card title="Durum Dağılımı">
            <Pie data={pieData} />
          </Card>
        </Col>

        <Col span={12}>
          <Card title="Zaman Serisi Grafiği">
            <Line data={lineData} />
          </Card>
        </Col>
      </Row>
    </Drawer>
  );
};

export default DetailDrawer;
